export default class UserViewmodel {
    public id: string = '';
    public firstName: string = '';
    public lastName: string = '';
    public email: string = '';
    public role: string = '';
}